import * as React from 'react';
import { TableCell } from 'types/common/table';
import { Member } from 'types/member';
import { getUtcUSFormatDateWithTime } from 'modules/utils/time';
import { DEFAULT_PAGE_SIZE } from 'constants/common';
import { getTableRowNumber } from 'modules/dataTable';
import CreateAnEmailVerificationLinkButton from 'components/member/memberListCell/CreateAnEmailVerificationLinkButton';
import { getStatus } from 'containers/memberdetail/memberDetailGeneral/generalInformation/utils';
import { MemberNameLink, TextWrapper } from 'components/member/common';

export const closetMemberListColumns = (
  totalItems: number,
  currentPageIndex: number,
): TableCell<Member>[] => [
  {
    align: 'center',
    name: 'No.',
    key: 'no',
    render: (rowData, columnData, rowIndex) =>
      getTableRowNumber(totalItems, DEFAULT_PAGE_SIZE, currentPageIndex, rowIndex),
  },
  {
    align: 'center',
    name: 'Email',
    key: 'email',
    render: (rowData: Member) => (
      <MemberNameLink to={`/member/${rowData.userid}/general`}>
        <TextWrapper>{rowData.email}</TextWrapper>
      </MemberNameLink>
    ),
  },
  {
    align: 'center',
    name: 'Email Verification',
    key: 'EmailVerification',
    render: (rowData: Member) => {
      if (rowData.verifyToken === null) {
        return <TextWrapper>Verified</TextWrapper>;
      }

      return <CreateAnEmailVerificationLinkButton userId={rowData.userid} />;
    },
  },
  {
    align: 'center',
    name: 'Integration Status',
    key: 'integrationStatus',
    width: '110px',
    render: (rowData: Member) => {
      return rowData.isIntegrated ? 'Yes' : 'No';
    },
  },
  {
    align: 'center',
    name: 'Status',
    key: 'status',
    width: '110px',
    render: (rowData: Member) => {
      return getStatus(rowData.status);
    },
  },
  {
    align: 'center',
    name: 'Marketing Agreement',
    key: 'marketingAgreement',
    width: '170px',
    render: (rowData: Member) => {
      return <>{rowData.marketingAgree ? 'Yes' : 'No'}</>;
    },
  },
  {
    align: 'center',
    name: 'Registered Date',
    key: 'registeredDate',
    width: '220px',
    render: (rowData: Member) => getUtcUSFormatDateWithTime(rowData.registrationDate, true),
  },
];
